import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import "./FormGroupAceleradora.scss";
import FormBottomAceleradora from "../form-bottom-aceleradora/FormBottomAceleradora";
import FormSectionAceleradora from "../form-section-aceleradora/FormSectionAceleradora";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import rawToReact from "../../../utils/rawToReact";

interface IGroupFormAceleradora {
    titulosFormulario: Array<any>;
    activeIndex: number;
    setActiveIndex: Dispatch<SetStateAction<number>>;
    activeWizard?: boolean;
    endIndex: number;
    setInputValue: any;
    formValues: any;
    handleSubmitForm: any;
    inputDisabled: string[];
    fieldsToSkip?: string[];
    validBirthDate?: boolean;
    isDisabledButton?: boolean;
    handleEvent?: any;
    dateState?: any;
    talleresData?: any;
    handleCancelButton?: any;
    handleAuthorizationMigP?: any;
    handleAuthorizationMigI?: any;
    flagDescrMagentaColor?: boolean;
    flagBotonVolver?: boolean;
    flagGTM?:string;
    handleBigCancelButton?: any;
    dateStateHelper?:boolean;
    setDateStateHelper?:any;
}

interface IErrorMessage {
    nombreId: string;
    errorMessage: string;
}

const FormGroupAceleradora = (props: IGroupFormAceleradora) => {
    const {
        titulosFormulario,
        activeIndex,
        setActiveIndex,
        activeWizard,
        endIndex,
        setInputValue,
        formValues,
        handleSubmitForm,
        inputDisabled,
        validBirthDate,
        isDisabledButton,
        fieldsToSkip,
        handleEvent,
        dateState,
        talleresData,
        handleCancelButton,
        handleAuthorizationMigP,
        handleAuthorizationMigI,
        flagDescrMagentaColor,
        flagBotonVolver,
        flagGTM,
        handleBigCancelButton,
        dateStateHelper,
        setDateStateHelper,
    } = props;
    
    // Estados para las validaciones basicas de los inputs.
    const [inputsErrorList, setInputErrorList] = useState<string[]>([]);
    const [customErrorMessageList, setCustomErrorMessageList] = useState<IErrorMessage[]>([]);

    //Deshabilita botón de continuar hasta que se completen los campos en cada seccion
    const [disableBottom, setdisableBottom] = useState(true);
    
    const groupBy = (list, key) => {
        return list.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };
    
    // Validaciones para los inputs
    const inputValidation = (type, value, nombreId) => {
        switch (type) {
            case "email":
                if (
                    !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                        value
                        ) &&
                        value
                ) {
                    setCustomErrorMessageList((prev: any) => [
                        ...prev,
                        { nombreId, errorMessage: "El correo no es válido." },
                    ]);
                    
                    return true;
                } else {
                    return false;
                }
                        
            case "mobile":
                // Valida que el input contenga minimo 10 digitos
                if (value?.length != 10 && value) {
                    setCustomErrorMessageList((prev: any) => [
                    ...prev,
                    { nombreId, errorMessage: "" },
                    ]);
                        return true;
                } else {
                    return false;
                }
            
            case "mobile-or-phone":
                // Valida que el input contenga minimo 7 digitos
                if (value?.length < 7 && value) {
                    setCustomErrorMessageList((prev: any) => [
                    ...prev,
                    { nombreId, errorMessage: "" },
                    ]);
                        return true;
                } else {
                    return false;
                }
                
            default:
                return false;
        }
    };
    const createSectionList = () => {
        const sectionList: any = [];
        
        titulosFormulario[activeIndex].referenciaFormulario.map((input) => {
            if (!sectionList[input.seccion]) {
                sectionList[input.seccion] = [];
            }
            sectionList[input.seccion].push(input);
        });
        return sectionList;
    };
    
    const sectionList = createSectionList();

    const createlistToValidated = () => {
        const sectionList: any = [];
        
        titulosFormulario[activeIndex].referenciaFormulario.map((input) => {
            if (!sectionList[input.seccion]) {
                sectionList[input.seccion] = [];
            }
            if (fieldsToSkip?.includes(input.nombreId)) return
            sectionList[input.seccion].push(input);
        });
        return sectionList;
    };
    const listToValidated = createlistToValidated();

    // Funcion para renderizar los campos de tipo json provenientes de contentful
    const contentfulRenderOptions = {
        renderNode: {
            [INLINES.HYPERLINK]: ({ data }: any, children) => (
                <a
                    style={{ color: "var(--color-magenta-white)" }}
                    href={data.uri}
                    target={"_blank"}
                    rel={"noopener noreferrer"}
                >
                    {children}
                </a>
            ),
            [BLOCKS.PARAGRAPH]: (node, children) => {
                return <p className="small-note">{children}</p>;
            },
            [BLOCKS.EMBEDDED_ASSET]: (node, children) => {
                return (
                    <p>
                        <img
                            src={`${node.data.target.fields.file.url}`}
                            alt={node.data.target.fields.description}
                        />
                    </p>
                );
            },
            [BLOCKS.UL_LIST]: (node, children) => {
                return (
                    <ul className="listaIntroAceleradora">
                        {children}
                    </ul>
                );
            },
        },
        renderText: (text) =>
            text.split("\n").flatMap((text, i) => [i > 0 && <br />, text]),
    };

    useEffect(() => {
        listToValidated[Object.keys(listToValidated)[0]].every( section => {
            if (!formValues[section.nombreId] && section.obligatorio){
                setdisableBottom(true);
                return false;
            }
            setdisableBottom(false);
            return true;
        });
    }, [formValues,activeIndex])
    
    // Lista los inputs requeridos
    const validateRequired = () => {
        setCustomErrorMessageList([]);
        let inputs: any = Object.entries(
            groupBy(
                titulosFormulario[activeIndex].referenciaFormulario,
                "section"
            )
        )[0][1];

        const fieldsMandatory = inputs.filter(input => {
            return !props.fieldsToSkip?.includes(input.nombreId)
        })
        
        inputs = fieldsMandatory;
        // Agrega los campos no diligenciados a la lista de error
        const errorList: string[] = [];
        inputs.map((input) => {
            if (input.obligatorio && !formValues[input.nombreId]) {
                errorList.push(input.nombreId);
            }

            if (
                inputValidation(
                    input.tipoCampo,
                    formValues[input.nombreId],
                    input.nombreId
                )
            ) {
                errorList.push(input.nombreId);
            }
        });

        //Controla el scroll y lo lleva hasta el campo con error, que no este diligenciado.
        if (errorList.length > 0) {
                document.getElementById(errorList[0])?.scrollIntoView({
                    behavior: "auto",
                    block: "center",
                    inline: "center",
                });
        }
        setInputErrorList(errorList);
        return errorList;
    };

    return (
        <div className="m-form-group-aceleradora">
            {
                props.titulosFormulario[activeIndex].descripcion && (
                    <div className={flagDescrMagentaColor && activeIndex != 0 ? `m-form-body-aceleradora__descripcionMagenta` : `m-form-body-aceleradora__descripcion`}>
                        <span>{rawToReact(props.titulosFormulario[activeIndex].descripcion.raw, contentfulRenderOptions)}</span>
                    </div>
                )
            }
            {/* Crea una seccion por cada una de las secciones configuradas para los campos en contentful */}
            <div className={`m-form-group-aceleradora__wrapper m-form-group-aceleradora__wrapper-${activeIndex}`}>
                {Object.entries(sectionList).map(([section, inputs]) => {
                    return (
                        <FormSectionAceleradora
                            key={`section-${section}`}
                            titleSection={section}
                            inputsSection={inputs}
                            setActiveIndex={setActiveIndex}
                            activeIndex={activeIndex}
                            formValues={formValues}
                            setInputValue={setInputValue}
                            inputsErrorList={inputsErrorList}
                            customErrorMessageList={customErrorMessageList}
                            inputDisabled={inputDisabled}
                            validBirthDate={validBirthDate}
                            dateState={dateState}
                            talleresData={talleresData}
                            dateStateHelper={dateStateHelper}
                            setDateStateHelper={setDateStateHelper}
                        ></FormSectionAceleradora>
                    );
                })}
            </div>
            {/* Renderiza autorizacion de datos, botones de confirmacion/navegacion en la parte inferior */}
            {
                <FormBottomAceleradora
                    inputs={titulosFormulario[activeIndex].referenciaFormulario}
                    titleButton={titulosFormulario[activeIndex].tituloBoton}
                    activeWizard={activeWizard}
                    setActiveIndex={setActiveIndex}
                    activeIndex={activeIndex}
                    endIndex={endIndex}
                    validateRequired={validateRequired}
                    setInputValue={setInputValue}
                    formValues={formValues}
                    inputsErrorList={inputsErrorList}
                    handleSubmitForm={handleSubmitForm}
                    isDisabled={disableBottom || isDisabledButton}
                    handleEvent={handleEvent}
                    flagGTM={flagGTM}
                    handleCancelButton={handleCancelButton}
                    handleAuthorizationMigP={handleAuthorizationMigP}
                    handleAuthorizationMigI={handleAuthorizationMigI}
                    flagBotonVolver={flagBotonVolver}
                    handleBigCancelButton={handleBigCancelButton}
                ></FormBottomAceleradora>
            }
        </div>
    );
};

export default FormGroupAceleradora;
